"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
/**
 * Retrieves a list that identify characters that break a word.
 *
 * @returns {string[]} List of word boundaries.
 */
function _default() {
  return [
  // Whitespace is always a word boundary.
  " ", "\\n", "\\r", "\\t",
  // NO-BREAK SPACE.
  "\u00a0", " ", ".", ",", "'", "(", ")", "\"", "+", "-", ";", "!", "?", ":", "/", "»", "«", "‹", "›", "<", ">"];
}